import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { useEffect } from "react";

// Insert Material Icons
const insertMaterialIcons = () => {
  const link = document.createElement('link');
  link.href = "https://fonts.googleapis.com/icon?family=Material+Icons";
  link.rel = "stylesheet";
  document.head.appendChild(link);
};

// Insert Montserrat and Inter fonts for UI
const insertFonts = () => {
  const link = document.createElement('link');
  link.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Montserrat:wght@600;700&family=Roboto+Mono:wght@500&display=swap";
  link.rel = "stylesheet";
  document.head.appendChild(link);
};

// Set title
const setDocumentTitle = () => {
  document.title = "FitTrack - Workout Planner";
};

// Execute setup
insertMaterialIcons();
insertFonts();
setDocumentTitle();

createRoot(document.getElementById("root")!).render(<App />);
